import { apiClientWithRefreshToken } from "@/api/apiClient";
import { Pagination, Client } from "@/v2/types";

export default async function FindAllClient({
    limit,
    skip,
    search,
    filter,
}: {
    skip?: number;
    limit?: number;
    search?: string;
    filter?: Record<string, string>;
}): Promise<{ data: Client[]; pagination: Pagination }> {
    const res = await apiClientWithRefreshToken({
        url: "/clients",
        method: "GET",
        params: {
            skip: skip ?? 0,
            limit: limit ?? 10,
            ...(search && { search }),
            ...filter,
        },
    });

    return res.data;
}
